import {
  // CtProductImage,
} from '@/models/interfaces/content-type'

import { ServiceEventHandlers } from '@/store/modules/services'
import { AxiosInterceptors, RequestHandler, ServiceResponse } from '@Protium/vue-ozone-utils'
import { Dispatch, DispatchOptions } from 'vuex'

import IO from './io'

const DISPATCH_DEFAULT = (type: string, payload?: any, options?: any): Promise<any> => { return Promise.reject('No dispatch implemented. pass it from the vuex module that generated this service') }

export enum ContentType {
  ProductImage = 'productImage',
}

enum ServiceDispatchType {
  Error = 'Error'
}

interface ServiceDispatch extends Dispatch {
  (type:ServiceDispatchType, payload?: any, options?: DispatchOptions): Promise<any>
}

interface ServiceProps {
  interceptors: AxiosInterceptors,
  getters: any,
  dispatch: ServiceDispatch,
  handlers: ServiceEventHandlers
}

interface ProductImage {
  fileName: string,
  file: File
}

export default class Cdn extends RequestHandler<any> {
  private io: IO | undefined
  private getters: any
  private dispatch: ServiceDispatch | ((type, callback?, options?) => Promise<any>)
  private handlers: ServiceEventHandlers

  constructor (config?: Record<string, any>, props?: ServiceProps) {
    super(
      {
        service: config?.service || { id: 'cdn', name: 'cdn' },
        ...(config || {}),
        // debug: process.env.NODE_ENV === 'production' ? false : (config?.debug || false),
        debug: false,
        requestConfig: {
          baseURL: process.env.OZONE_AUTH_PROXY_URL,
          withCredentials: true,
          ...((config || {}).requestConfig || {}),
          headers: {
            ...(((config || {}).requestConfig || {}).headers || {}),
            'x-ozone-app-type': process.env.OZONE_SERVICE_TYPE_ID,
            Authorization: process.env.API_AUTH_TOKEN,
            'x-service-config': '{"limit": 1000}'
          }
        }
      },
      props
    )

    this.getters = props?.getters
    this.dispatch = props?.dispatch || DISPATCH_DEFAULT
    this.handlers = props?.handlers || { Error: e => Promise.reject(e), Warn: e => Promise.reject(e), Fatal: e => Promise.reject(e), Unauthorized: e => Promise.reject(e) }

    if (((config || {}).service || {}).io) {
      this.io = new IO(config?.requestConfig.baseURL)
      this.io.init('/cdn')
    }
  }

  // TEMP fix for image name
  async getImageByUrl (query) {
    const image = await this.get('product.image', [{ field: query, match: true }])
    return image
    // .catch(e => this.handlers.Error(e))
  }

  getImageByUUID (query) {
    return this.get('productImage.get', query)
    .catch(e => this.handlers.Error(e))
  }

  postImage (data) {
    // console.log('->', data)
    return this.put('productImage.create', data)
    .catch(e => this.handlers.Error(e))
  }
}
